// extracted by mini-css-extract-plugin
module.exports = {"Link":"member-operations__LinkButton__Link"};